import { RuleEngine } from '@8fig/rule-engine';
import React, { createContext } from 'react';
import { Feature } from './feature';

export interface ABTestingContextData {
  features: Feature[];
  ruleEngine?: RuleEngine;
}

const defaultData: ABTestingContextData = {
  features: [],
};

export const ABTestingContext = createContext(defaultData);
